import React, { useState } from 'react';
import { ArrowButton } from '../../../../ui/General/ArrowButton/ArrowButton.tsx';
import { cn } from '../../../../utils/cn.ts';

/**
 * Открывающаяся по клику таблица
 * @param children - контент таблицы
 * @param title - заголовок таблицы
 * @returns 
 */
export const ProductOpenTable: React.FC<{ children: React.ReactNode, title: string }> = ({ children, title }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={cn('mb-1 slide-down', isOpen && 'active')}>
            <button className='w-full flex justify-between items-center px-0 py-2 font-bold text-base text-left hover:text-orange-600 transition'
                onClick={() => setIsOpen(!isOpen)}>
                <span>{title}</span>
                <span className='ml-2'><ArrowButton state={isOpen ? 'up' : 'down'} /></span>
            </button>
            {children}
        </div>
    );
};